<template lang='pug'>
  .view-container
    .content-container
      router-link.record(v-for='record in records' :key='record.id' :to="{name:'view',params:{id:record.id}}") 
        .title {{record.name}}
        .date {{moment(record.date).format("LLLL")}}

</template>

<script>
export default {
  data(){
    return {
      moment: require('moment'),
    }
  },
  computed: {
    records(){
      return this.$store.state.records.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    },
  },
  methods: {
    
  },
  mounted(){
    
  },
}
</script>

<style scoped lang="sass">
@import ../sass/variables
$max-width: 30em
.view-container
  background-color: var(--bg2)
  padding-top: 1em

  .content-container
    margin: auto
    max-width: $max-width

    .record
      text-decoration: none
      color: inherit
      padding: 1em 0
      display: block
      border-bottom: 1px solid var(--bg3)
      .title
        font-size: $font-size-1
      .date
        font-size: $font-size--1
        color: var(--bg4)


</style>
